import { signal } from '@angular/core';

export class WindowContentService {
  /** PROPERTIES **/
  /****/
  private readonly _width = signal(0);

  get widthSignal() {
    return this._width.asReadonly();
  }

  set width(value: number) {
    this._width.set(value);
  }

  /****/
  private readonly _height = signal(0);

  get heightSignal() {
    return this._height.asReadonly();
  }

  set height(value: number) {
    this._height.set(value);
  }
}
